(function () {
  var SPJ_WA_STORAGE_KEY = 'spjCustomJewelleryFullWhatsAppMessageV27';

  function restoreWhatsAppSuccessLink(root) {
    var button = root ? root.querySelector('[data-spj-whatsapp-button]') : null;
    if (!button) return;
    var waNumber = String(button.getAttribute('data-spj-wa-number') || '').replace(/\D/g, '');
    if (!waNumber) return;
    try {
      var savedMessage = window.sessionStorage ? sessionStorage.getItem(SPJ_WA_STORAGE_KEY) : '';
      if (savedMessage) {
        button.href = 'https://wa.me/' + waNumber + '?text=' + encodeURIComponent(savedMessage);
      }
    } catch (e) {}
  }

  function init(root) {
    if (!root || root.getAttribute('data-spj-initialized') === 'true') return;
    root.setAttribute('data-spj-initialized', 'true');
    restoreWhatsAppSuccessLink(root);

    var form = root.querySelector('.spj-form');
    if (!form) return;

    var steps = [].slice.call(root.querySelectorAll('[data-spj-step]'));
    var progress = [].slice.call(root.querySelectorAll('[data-spj-progress]'));
    var errorBox = root.querySelector('[data-spj-step-error]');
    var summaryField = root.querySelector('[data-spj-summary-field]');
    var emailBody = root.querySelector('[data-spj-email-body]');
    var fileInput = root.querySelector('[data-spj-files]');
    var fileList = root.querySelector('[data-spj-file-list]');
    var fileNames = root.querySelector('[data-spj-file-names]');
    var review = root.querySelector('[data-spj-review]');
    var preferredDateInput = root.querySelector('[data-spj-preferred-date]');
    var dateHelp = root.querySelector('[data-spj-date-help]');
    var stateSelect = root.querySelector('[data-spj-state]');
    var citySelect = root.querySelector('[data-spj-city]');
    var pincodeSelect = root.querySelector('[data-spj-pincode]');
    var phoneInput = root.querySelector('[data-spj-phone]');
    var emailInput = root.querySelector('[data-spj-email]');
    var addressData = window.SPJ_INDIA_PINCODE_DATA || {};
    var current = 1;

    function esc(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
      });
    }

    function named(name) {
      return [].slice.call(form.querySelectorAll('[name="' + name.replace(/"/g, '\\"') + '"]'));
    }

    function value(name) {
      var els = named(name);
      if (!els.length) return '';
      if (els[0].type === 'radio' || els[0].type === 'checkbox') {
        for (var i = 0; i < els.length; i++) {
          if (els[i].checked) return els[i].value || 'Yes';
        }
        return '';
      }
      return els[0].value || '';
    }

    function clean(v) {
      return String(v || '').trim();
    }

    function formatDate(v) {
      if (!v) return '';
      var parts = v.split('-');
      if (parts.length !== 3) return v;
      var d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      if (isNaN(d.getTime())) return v;
      try {
        return d.toLocaleDateString('en-IN', {day:'2-digit', month:'short', year:'numeric'});
      } catch (e) {
        return parts[2] + '-' + parts[1] + '-' + parts[0];
      }
    }

    function pad2(n) {
      return String(n).padStart(2, '0');
    }

    function dateToISO(d) {
      return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
    }

    function addOneCalendarMonth(fromDate) {
      var year = fromDate.getFullYear();
      var month = fromDate.getMonth();
      var day = fromDate.getDate();
      var targetMonthIndex = month + 1;
      var targetYear = year + Math.floor(targetMonthIndex / 12);
      var targetMonth = targetMonthIndex % 12;
      var daysInTargetMonth = new Date(targetYear, targetMonth + 1, 0).getDate();
      return new Date(targetYear, targetMonth, Math.min(day, daysInTargetMonth));
    }

    function setPreferredDateMinimum() {
      if (!preferredDateInput) return;
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      var minDate = addOneCalendarMonth(today);
      var minISO = dateToISO(minDate);
      preferredDateInput.min = minISO;
      preferredDateInput.setAttribute('data-spj-min-date', minISO);
      if (dateHelp) {
        dateHelp.textContent = 'Earliest selectable date: ' + formatDate(minISO) + ' (one calendar month from today).';
      }
      if (preferredDateInput.value && preferredDateInput.value < minISO) {
        preferredDateInput.value = '';
      }
    }


    function prettyPlaceName(v) {
      var s = clean(v).toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
      var replacements = {
        'Andaman And Nicobar Islands':'Andaman and Nicobar Islands',
        'Andhra Pradesh':'Andhra Pradesh',
        'Arunachal Pradesh':'Arunachal Pradesh',
        'Dadra And Nagar Haveli And Daman And Diu':'Dadra and Nagar Haveli and Daman and Diu',
        'The Dadra And Nagar Haveli And Daman And Diu':'Dadra and Nagar Haveli and Daman and Diu',
        'Jammu And Kashmir':'Jammu and Kashmir',
        'Tamil Nadu':'Tamil Nadu',
        'Uttar Pradesh':'Uttar Pradesh',
        'West Bengal':'West Bengal'
      };
      return replacements[s] || s;
    }

    function resetSelect(select, placeholder, disabled) {
      if (!select) return;
      select.innerHTML = '';
      var opt = document.createElement('option');
      opt.value = '';
      opt.textContent = placeholder;
      select.appendChild(opt);
      select.disabled = !!disabled;
    }

    function selectedDataKey(select) {
      if (!select || select.selectedIndex < 0) return '';
      var opt = select.options[select.selectedIndex];
      return opt ? (opt.getAttribute('data-key') || '') : '';
    }

    function populateStates() {
      if (!stateSelect || !citySelect || !pincodeSelect) return;
      resetSelect(stateSelect, 'Select state', false);
      resetSelect(citySelect, 'Select state first', true);
      resetSelect(pincodeSelect, 'Select city first', true);

      var states = Object.keys(addressData).sort(function (a, b) {
        return prettyPlaceName(a).localeCompare(prettyPlaceName(b), 'en');
      });
      for (var i = 0; i < states.length; i++) {
        var opt = document.createElement('option');
        opt.value = prettyPlaceName(states[i]);
        opt.textContent = prettyPlaceName(states[i]);
        opt.setAttribute('data-key', states[i]);
        stateSelect.appendChild(opt);
      }
    }

    function populateCities() {
      if (!stateSelect || !citySelect || !pincodeSelect) return;
      var stateKey = selectedDataKey(stateSelect);
      resetSelect(citySelect, stateKey ? 'Select city' : 'Select state first', !stateKey);
      resetSelect(pincodeSelect, 'Select city first', true);
      if (!stateKey || !addressData[stateKey]) return;

      var cities = Object.keys(addressData[stateKey]).sort(function (a, b) {
        return prettyPlaceName(a).localeCompare(prettyPlaceName(b), 'en');
      });
      for (var i = 0; i < cities.length; i++) {
        var opt = document.createElement('option');
        opt.value = prettyPlaceName(cities[i]);
        opt.textContent = prettyPlaceName(cities[i]);
        opt.setAttribute('data-key', cities[i]);
        citySelect.appendChild(opt);
      }
    }

    function populatePincodes() {
      if (!stateSelect || !citySelect || !pincodeSelect) return;
      var stateKey = selectedDataKey(stateSelect);
      var cityKey = selectedDataKey(citySelect);
      resetSelect(pincodeSelect, cityKey ? 'Select PIN code' : 'Select city first', !cityKey);
      if (!stateKey || !cityKey || !addressData[stateKey] || !addressData[stateKey][cityKey]) return;

      var pins = addressData[stateKey][cityKey].slice().sort();
      for (var i = 0; i < pins.length; i++) {
        var opt = document.createElement('option');
        opt.value = pins[i];
        opt.textContent = pins[i];
        pincodeSelect.appendChild(opt);
      }
    }

    function initAddressSelectors() {
      if (!stateSelect || !citySelect || !pincodeSelect) return;
      populateStates();
      stateSelect.addEventListener('change', function () {
        populateCities();
        buildSummary();
      });
      citySelect.addEventListener('change', function () {
        populatePincodes();
        buildSummary();
      });
      pincodeSelect.addEventListener('change', buildSummary);
    }

    function initPhoneValidation() {
      if (!phoneInput) return;

      function keepDigitsOnly() {
        var cleaned = String(phoneInput.value || '').replace(/\D/g, '').slice(0, 15);
        if (phoneInput.value !== cleaned) phoneInput.value = cleaned;
        if (phoneInput.setCustomValidity) {
          phoneInput.setCustomValidity(cleaned.length >= 10 && cleaned.length <= 15 ? '' : 'Enter a valid Mobile / WhatsApp number using 10 to 15 digits only.');
        }
      }

      phoneInput.addEventListener('input', function () {
        keepDigitsOnly();
        buildSummary();
      });
      phoneInput.addEventListener('paste', function () {
        setTimeout(function () {
          keepDigitsOnly();
          buildSummary();
        }, 0);
      });
      phoneInput.addEventListener('blur', keepDigitsOnly);
      keepDigitsOnly();
    }

    function setError(message, target) {
      if (!errorBox) return;
      errorBox.textContent = message || 'Please complete the required field before continuing.';
      errorBox.classList.add('is-open');
      if (target && target.scrollIntoView) target.scrollIntoView({behavior:'smooth', block:'center'});
    }

    function clearError() {
      if (errorBox) errorBox.classList.remove('is-open');
    }

    function validateStep() {
      clearError();
      var step = root.querySelector('[data-spj-step="' + current + '"]');
      if (!step) return true;

      var groups = [].slice.call(step.querySelectorAll('[data-required-group]'));
      for (var g = 0; g < groups.length; g++) {
        var radios = groups[g].querySelectorAll('input[type="radio"]');
        var ok = false;
        for (var r = 0; r < radios.length; r++) {
          if (radios[r].checked) { ok = true; break; }
        }
        if (!ok) {
          setError('Please select ' + groups[g].getAttribute('data-required-group') + ' before continuing.', groups[g]);
          return false;
        }
      }

      var required = [].slice.call(step.querySelectorAll('input[required],select[required],textarea[required]'));
      for (var i = 0; i < required.length; i++) {
        var el = required[i];
        if (el.type === 'checkbox' && !el.checked) {
          setError('Please accept all required confirmations before submitting.', el);
          return false;
        }
        if (el.type !== 'checkbox' && !el.checkValidity()) {
          setError('Please complete all required fields before continuing.', el);
          if (el.reportValidity) el.reportValidity();
          return false;
        }
      }

      if (current === 6 && preferredDateInput) {
        var minDateValue = preferredDateInput.getAttribute('data-spj-min-date') || preferredDateInput.min || '';
        var chosenDateValue = clean(preferredDateInput.value);
        if (chosenDateValue && minDateValue && chosenDateValue < minDateValue) {
          setError('Preferred Date must be ' + formatDate(minDateValue) + ' or later.', preferredDateInput);
          if (preferredDateInput.setCustomValidity) preferredDateInput.setCustomValidity('Please choose ' + formatDate(minDateValue) + ' or later.');
          if (preferredDateInput.reportValidity) preferredDateInput.reportValidity();
          return false;
        }
        if (preferredDateInput.setCustomValidity) preferredDateInput.setCustomValidity('');
      }

      if (current === 5) {
        var p = value('contact[Personalisation]');
        var pt = value('contact[Personalisation Text]');
        if (p && p !== 'No Personalisation' && !clean(pt)) {
          setError('Please enter the personalisation or engraving details.', form.querySelector('[name="contact[Personalisation Text]"]'));
          return false;
        }
      }

      if (current === 7 && phoneInput) {
        var phone = clean(phoneInput.value);
        if (!/^[0-9]{10,15}$/.test(phone)) {
          if (phoneInput.setCustomValidity) phoneInput.setCustomValidity('Enter a valid Mobile / WhatsApp number using 10 to 15 digits only.');
          setError('Mobile / WhatsApp must contain numbers only and be 10 to 15 digits long.', phoneInput);
          if (phoneInput.reportValidity) phoneInput.reportValidity();
          return false;
        }
        if (phoneInput.setCustomValidity) phoneInput.setCustomValidity('');
      }
      return true;
    }

    function updateConditionals() {
      var metal = value('contact[Metal]');
      var gold = root.querySelector('[data-spj-gold-options]');
      if (gold) gold.hidden = metal !== 'Gold';

      var stone = value('contact[Stone Preference]');
      var stoneBox = root.querySelector('[data-spj-stone-options]');
      if (stoneBox) stoneBox.hidden = stone === 'No Stones' || stone === '';

      var personal = value('contact[Personalisation]');
      var personalBox = root.querySelector('[data-spj-personal-text]');
      if (personalBox) personalBox.hidden = !personal || personal === 'No Personalisation';

      var type = value('contact[Jewellery Type]');
      var sizeLabel = root.querySelector('[data-spj-size-label]');
      if (sizeLabel) {
        var labels = {
          'Ring':'Ring size',
          'Bangle':'Bangle size',
          'Bracelet':'Wrist / bracelet size',
          'Necklace':'Preferred necklace length',
          'Mangalsutra':'Preferred mangalsutra length',
          'Earrings':'Earring size / dimensions',
          'Pendant':'Pendant size / dimensions',
          'Nose Pin':'Nose pin size / dimensions'
        };
        sizeLabel.textContent = labels[type] || 'Jewellery size / dimensions';
      }
    }

    function reviewRows() {
      var metal = value('contact[Metal]');
      var stone = value('contact[Stone Preference]');
      var personal = value('contact[Personalisation]');
      var rows = [
        ['Jewellery', value('contact[Jewellery Type]')],
        ['Design idea', value('contact[Design Idea]')],
        ['Reference link', value('contact[Reference Link]')],
        ['Reference files', fileNames ? fileNames.value : ''],
        ['Metal', metal]
      ];

      if (metal === 'Gold') {
        rows.push(['Gold purity', value('contact[Gold Purity]')]);
        rows.push(['Gold colour', value('contact[Gold Colour]')]);
      }

      rows.push(['Stone preference', stone]);
      if (stone && stone !== 'No Stones') {
        rows.push(['Stone shape', value('contact[Stone Shape]')]);
        rows.push(['Stone quality', value('contact[Stone Quality]')]);
        rows.push(['Stone size', value('contact[Stone Size]')]);
        rows.push(['Stone details', value('contact[Stone Details]')]);
      }

      rows.push(['Jewellery size', value('contact[Jewellery Size]')]);
      rows.push(['Target weight', value('contact[Target Weight]')]);
      rows.push(['Special requirements', value('contact[Special Requirements]')]);
      rows.push(['Personalisation', personal]);
      if (personal && personal !== 'No Personalisation') {
        rows.push(['Personalisation text', value('contact[Personalisation Text]')]);
      }
      rows.push(['Budget', value('contact[Budget]')]);
      rows.push(['Occasion', value('contact[Occasion]')]);
      rows.push(['Preferred date', formatDate(value('contact[Preferred Date]'))]);
      rows.push(['Name', value('contact[name]')]);
      rows.push(['Phone / WhatsApp', value('contact[phone]')]);
      rows.push(['Email', value('contact[email]')]);
      rows.push(['City', value('contact[City]')]);
      rows.push(['State', value('contact[State]')]);
      rows.push(['PIN Code', value('contact[PIN Code]')]);
      rows.push(['Preferred contact', value('contact[Preferred Contact Method]')]);
      return rows;
    }

    function buildSummary() {
      var rows = reviewRows();
      var lines = [];
      for (var i = 0; i < rows.length; i++) {
        if (clean(rows[i][1])) lines.push(rows[i][0] + ': ' + clean(rows[i][1]));
      }
      if (summaryField) summaryField.value = lines.join('\n');

      if (review) {
        var html = '';
        for (var j = 0; j < rows.length; j++) {
          if (!clean(rows[j][1])) continue;
          html += '<div class="spj-review-row"><span>' + esc(rows[j][0]) + '</span><strong>' + esc(rows[j][1]) + '</strong></div>';
        }
        review.innerHTML = html || '<div class="spj-review-row"><span>Summary</span><strong>Complete previous steps to review your request.</strong></div>';
      }
    }

    function addLine(arr, label, val) {
      val = clean(val);
      if (val) arr.push(label + ': ' + val);
    }

    function buildProfessionalRequestCore() {
      var metal = value('contact[Metal]');
      var stone = value('contact[Stone Preference]');
      var personal = value('contact[Personalisation]');
      var files = fileNames ? clean(fileNames.value) : '';
      var sections = [];
      var lines;

      lines = [];
      addLine(lines, 'Jewellery Type', value('contact[Jewellery Type]'));
      if (lines.length) sections.push('STEP 1 — JEWELLERY\n' + lines.join('\n'));

      lines = [];
      addLine(lines, 'Design Idea', value('contact[Design Idea]'));
      addLine(lines, 'Reference Link', value('contact[Reference Link]'));
      if (files) addLine(lines, 'Reference Files Selected', files);
      if (lines.length) sections.push('STEP 2 — DESIGN INSPIRATION\n' + lines.join('\n'));

      lines = [];
      addLine(lines, 'Metal', metal);
      if (metal === 'Gold') {
        addLine(lines, 'Gold Purity', value('contact[Gold Purity]'));
        addLine(lines, 'Gold Colour', value('contact[Gold Colour]'));
      }
      if (lines.length) sections.push('STEP 3 — METAL PREFERENCES\n' + lines.join('\n'));

      lines = [];
      addLine(lines, 'Stone Preference', stone);
      if (stone && stone !== 'No Stones') {
        addLine(lines, 'Stone Shape', value('contact[Stone Shape]'));
        addLine(lines, 'Stone Quality', value('contact[Stone Quality]'));
        addLine(lines, 'Stone Size', value('contact[Stone Size]'));
        addLine(lines, 'Stone Details', value('contact[Stone Details]'));
      }
      addLine(lines, 'Jewellery Size / Dimensions', value('contact[Jewellery Size]'));
      addLine(lines, 'Target Gold Weight', value('contact[Target Weight]'));
      addLine(lines, 'Special Requirements', value('contact[Special Requirements]'));
      if (lines.length) sections.push('STEP 4 — STONES & SIZE\n' + lines.join('\n'));

      lines = [];
      addLine(lines, 'Personalisation', personal);
      if (personal && personal !== 'No Personalisation') {
        addLine(lines, 'Personalisation Text', value('contact[Personalisation Text]'));
      }
      if (lines.length) sections.push('STEP 5 — PERSONALISATION\n' + lines.join('\n'));

      lines = [];
      addLine(lines, 'Budget', value('contact[Budget]'));
      addLine(lines, 'Occasion', value('contact[Occasion]'));
      addLine(lines, 'Required Date', formatDate(value('contact[Preferred Date]')));
      if (lines.length) sections.push('STEP 6 — BUDGET & OCCASION\n' + lines.join('\n'));

      lines = [];
      addLine(lines, 'Name', value('contact[name]'));
      addLine(lines, 'Phone / WhatsApp', value('contact[phone]'));
      addLine(lines, 'Email', value('contact[email]'));
      addLine(lines, 'City', value('contact[City]'));
      addLine(lines, 'State', value('contact[State]'));
      addLine(lines, 'PIN Code', value('contact[PIN Code]'));
      addLine(lines, 'Preferred Contact Method', value('contact[Preferred Contact Method]'));
      if (lines.length) sections.push('STEP 7 — CUSTOMER DETAILS\n' + lines.join('\n'));

      return {
        body: 'SWARNAPRABHA JEWELS — CUSTOM JEWELLERY REQUEST\n\n' + sections.join('\n\n'),
        files: files
      };
    }

    function buildProfessionalEmailBody() {
      var request = buildProfessionalRequestCore();
      var note = request.files ? '\n\nFILE NOTE\nActual reference files are not attached to this Shopify email. Customer should send them via WhatsApp.' : '';
      var text = request.body + note;
      if (emailBody) emailBody.value = text;
      return text;
    }

    function buildFullWhatsAppMessage() {
      var request = buildProfessionalRequestCore();
      var intro = 'Hello SWARNAPRABHA JEWELS,\n\nI have submitted my Custom Jewellery Order Request. Please review the complete details below.\n\n';
      var fileNote = request.files
        ? '\n\nREFERENCE FILES\nSelected file(s): ' + request.files + '\nI will attach/send these reference files in this WhatsApp chat.'
        : '\n\nPlease review my custom jewellery request and contact me for the next step.';
      return intro + request.body + fileNote;
    }

    function persistWhatsAppMessage() {
      try {
        if (window.sessionStorage) sessionStorage.setItem(SPJ_WA_STORAGE_KEY, buildFullWhatsAppMessage());
      } catch (e) {}
    }

    function prepareCleanEmailPayload() {
      buildProfessionalEmailBody();

      var keep = {
        'contact[Request Type]': true,
        'contact[name]': true,
        'contact[phone]': true,
        'contact[email]': true,
        'contact[body]': true
      };

      var controls = [].slice.call(form.querySelectorAll('[name^="contact["]'));
      for (var i = 0; i < controls.length; i++) {
        var c = controls[i];
        if (!keep[c.name]) c.disabled = true;
      }
    }

    function showStep(n) {
      current = Math.max(1, Math.min(7, n));
      for (var i = 0; i < steps.length; i++) {
        steps[i].hidden = Number(steps[i].getAttribute('data-spj-step')) !== current;
      }
      for (var j = 0; j < progress.length; j++) {
        var p = Number(progress[j].getAttribute('data-spj-progress'));
        progress[j].classList.toggle('is-active', p === current);
        progress[j].classList.toggle('is-done', p < current);
      }
      clearError();
      updateConditionals();
      buildSummary();
      var card = root.querySelector('.spj-card');
      if (card && card.scrollIntoView) card.scrollIntoView({behavior:'smooth', block:'start'});
    }

    root.addEventListener('click', function (e) {
      var next = e.target.closest ? e.target.closest('[data-spj-next]') : null;
      var back = e.target.closest ? e.target.closest('[data-spj-back]') : null;
      if (next) {
        e.preventDefault();
        if (validateStep()) showStep(current + 1);
      }
      if (back) {
        e.preventDefault();
        showStep(current - 1);
      }
    });

    form.addEventListener('change', function (e) {
      clearError();
      if (preferredDateInput && e.target === preferredDateInput) {
        if (preferredDateInput.setCustomValidity) preferredDateInput.setCustomValidity('');
        var minDateValue = preferredDateInput.getAttribute('data-spj-min-date') || preferredDateInput.min || '';
        if (preferredDateInput.value && minDateValue && preferredDateInput.value < minDateValue) {
          preferredDateInput.setCustomValidity('Please choose ' + formatDate(minDateValue) + ' or later.');
        }
      }
      updateConditionals();
      buildSummary();
    });
    form.addEventListener('input', buildSummary);

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var names = [];
        for (var i = 0; i < fileInput.files.length && i < 5; i++) names.push(fileInput.files[i].name);
        if (fileNames) fileNames.value = names.join(', ');
        if (fileList) {
          fileList.innerHTML = '';
          for (var j = 0; j < names.length; j++) {
            var span = document.createElement('span');
            span.className = 'spj-file';
            span.textContent = names[j];
            fileList.appendChild(span);
          }
        }
        buildSummary();
      });
    }

    form.addEventListener('submit', function (e) {
      current = 7;
      if (!validateStep()) {
        e.preventDefault();
        showStep(7);
        return false;
      }
      buildSummary();
      persistWhatsAppMessage();
      prepareCleanEmailPayload();
    });

    setPreferredDateMinimum();
    initAddressSelectors();
    initPhoneValidation();
    updateConditionals();
    buildSummary();
    showStep(1);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll ? (scope || document).querySelectorAll('[data-spj-order-root]') : [];
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
